export const setUserReducer = (userData) => {
    return {
        type: 'SET_USER_DATA',
        payload: userData,
    };
};

const initialState = {
    user: null,
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_USER_DATA':
            return {
                ...state,
                user: action.payload,
            };
        default:
            return state;
    }
};

export default userReducer;
